import { MaintenanceMessage } from './maintenance-message'

export default MaintenanceMessage
